import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetHardgoodsInventoryGridQueryVariables = Types.Exact<{
  siteLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.HardgoodsInventoryGridDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.HardgoodsInventoryGridDocumentSortInput> | Types.HardgoodsInventoryGridDocumentSortInput>;
}>;


export type GetHardgoodsInventoryGridQuery = { __typename?: 'Query', hardgoodsInventoryGrid?: { __typename?: 'HardgoodsInventoryGridConnection', totalCount: number, nodes?: Array<{ __typename?: 'HardgoodsInventoryGridDocument', id: string, materialItemId: string, siteLocationId: string, activeAssignmentId?: string | null, activeAssignmentStatus?: Types.CycleCountAssignmentStatus | null, lastEventAt: Types.TDateISO, bins: Array<{ __typename?: 'KeyValuePairOfStringAndHardgoodsBinBreakdown', key: string, value: { __typename?: 'HardgoodsBinBreakdown', onHand: number, lastCountedAt?: Types.TDateISO | null } }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetHardgoodsAvailabilityQueryVariables = Types.Exact<{
  siteLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.HardgoodsInventoryGridDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.HardgoodsInventoryGridDocumentSortInput> | Types.HardgoodsInventoryGridDocumentSortInput>;
}>;


export type GetHardgoodsAvailabilityQuery = { __typename?: 'Query', hardgoodsInventoryGrid?: { __typename?: 'HardgoodsInventoryGridConnection', totalCount: number, nodes?: Array<{ __typename?: 'HardgoodsInventoryGridDocument', id: string, materialItemId: string, siteLocationId: string, committed: number, available: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type HardgoodsRequiredItemFragment = { __typename?: 'HardgoodsRequiredItem', materialItemId: string, materialItemName: string, materialItemCategory: string, requiredQuantity: number, available: number, netShort: number, jobContainerCount: number, unitLabel?: string | null, eachesPerContainer?: number | null };

export type GetHardgoodsRequiredByNeededWeekRangeQueryVariables = Types.Exact<{
  siteLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  neededWeekFromIsoYear: Types.Scalars['Int']['input'];
  neededWeekFromIsoWeek: Types.Scalars['Int']['input'];
  neededWeekToIsoYear: Types.Scalars['Int']['input'];
  neededWeekToIsoWeek: Types.Scalars['Int']['input'];
}>;


export type GetHardgoodsRequiredByNeededWeekRangeQuery = { __typename?: 'Query', hardgoodsRequiredByNeededWeekRange: { __typename?: 'HardgoodsRequiredSummary', items: Array<{ __typename?: 'HardgoodsRequiredItem', materialItemId: string, materialItemName: string, materialItemCategory: string, requiredQuantity: number, available: number, netShort: number, jobContainerCount: number, unitLabel?: string | null, eachesPerContainer?: number | null }> } };

export type HardgoodsAssignmentTaskFragment = { __typename?: 'AssignmentTaskSummary', binLocationId: string, completedAt?: Types.TDateISO | null, materialItemId: string, startedAt?: Types.TDateISO | null, status: Types.CycleCountTaskStatus, taskId: string };

export type HardgoodsAssignmentSummaryFragment = { __typename?: 'AssignmentSummaryDocument', assignmentId: string, createdAt: Types.TDateISO, dueBy: Types.TDateISO, notes?: string | null, previousWorkerUserId?: string | null, status: Types.CycleCountAssignmentStatus, workerReassignedAt?: Types.TDateISO | null, workerUserId: string, tasks: Array<{ __typename?: 'KeyValuePairOfStringAndAssignmentTaskSummary', key: string, value: { __typename?: 'AssignmentTaskSummary', binLocationId: string, completedAt?: Types.TDateISO | null, materialItemId: string, startedAt?: Types.TDateISO | null, status: Types.CycleCountTaskStatus, taskId: string } }> };

export type GetAssignmentHistoryByItemQueryVariables = Types.Exact<{
  materialItemId: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetAssignmentHistoryByItemQuery = { __typename?: 'Query', assignmentHistoryByItem: Array<{ __typename?: 'AssignmentSummaryDocument', assignmentId: string, createdAt: Types.TDateISO, dueBy: Types.TDateISO, notes?: string | null, previousWorkerUserId?: string | null, status: Types.CycleCountAssignmentStatus, workerReassignedAt?: Types.TDateISO | null, workerUserId: string, tasks: Array<{ __typename?: 'KeyValuePairOfStringAndAssignmentTaskSummary', key: string, value: { __typename?: 'AssignmentTaskSummary', binLocationId: string, completedAt?: Types.TDateISO | null, materialItemId: string, startedAt?: Types.TDateISO | null, status: Types.CycleCountTaskStatus, taskId: string } }> }> };

export const HardgoodsRequiredItemFragmentDoc = new TypedDocumentString(`
    fragment HardgoodsRequiredItem on HardgoodsRequiredItem {
  materialItemId
  materialItemName
  materialItemCategory
  requiredQuantity
  available
  netShort
  jobContainerCount
  unitLabel
  eachesPerContainer
}
    `, {"fragmentName":"HardgoodsRequiredItem"});
export const HardgoodsAssignmentTaskFragmentDoc = new TypedDocumentString(`
    fragment HardgoodsAssignmentTask on AssignmentTaskSummary {
  binLocationId
  completedAt
  materialItemId
  startedAt
  status
  taskId
}
    `, {"fragmentName":"HardgoodsAssignmentTask"});
export const HardgoodsAssignmentSummaryFragmentDoc = new TypedDocumentString(`
    fragment HardgoodsAssignmentSummary on AssignmentSummaryDocument {
  assignmentId
  createdAt
  dueBy
  notes
  previousWorkerUserId
  status
  tasks {
    key
    value {
      ...HardgoodsAssignmentTask
    }
  }
  workerReassignedAt
  workerUserId
}
    fragment HardgoodsAssignmentTask on AssignmentTaskSummary {
  binLocationId
  completedAt
  materialItemId
  startedAt
  status
  taskId
}`, {"fragmentName":"HardgoodsAssignmentSummary"});
export const GetHardgoodsInventoryGridDocument = new TypedDocumentString(`
    query GetHardgoodsInventoryGrid($siteLocationId: String, $first: Int, $after: String, $last: Int, $before: String, $where: HardgoodsInventoryGridDocumentFilterInput, $order: [HardgoodsInventoryGridDocumentSortInput!]) {
  hardgoodsInventoryGrid(
    siteLocationId: $siteLocationId
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      id
      materialItemId
      siteLocationId
      bins {
        key
        value {
          onHand
          lastCountedAt
        }
      }
      activeAssignmentId
      activeAssignmentStatus
      lastEventAt
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetHardgoodsAvailabilityDocument = new TypedDocumentString(`
    query GetHardgoodsAvailability($siteLocationId: String, $first: Int, $after: String, $where: HardgoodsInventoryGridDocumentFilterInput, $order: [HardgoodsInventoryGridDocumentSortInput!]) {
  hardgoodsInventoryGrid(
    siteLocationId: $siteLocationId
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      id
      materialItemId
      siteLocationId
      committed
      available
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetHardgoodsRequiredByNeededWeekRangeDocument = new TypedDocumentString(`
    query GetHardgoodsRequiredByNeededWeekRange($siteLocationId: String, $neededWeekFromIsoYear: Int!, $neededWeekFromIsoWeek: Int!, $neededWeekToIsoYear: Int!, $neededWeekToIsoWeek: Int!) {
  hardgoodsRequiredByNeededWeekRange(
    siteLocationId: $siteLocationId
    neededWeekFromIsoYear: $neededWeekFromIsoYear
    neededWeekFromIsoWeek: $neededWeekFromIsoWeek
    neededWeekToIsoYear: $neededWeekToIsoYear
    neededWeekToIsoWeek: $neededWeekToIsoWeek
  ) {
    items {
      ...HardgoodsRequiredItem
    }
  }
}
    fragment HardgoodsRequiredItem on HardgoodsRequiredItem {
  materialItemId
  materialItemName
  materialItemCategory
  requiredQuantity
  available
  netShort
  jobContainerCount
  unitLabel
  eachesPerContainer
}`);
export const GetAssignmentHistoryByItemDocument = new TypedDocumentString(`
    query GetAssignmentHistoryByItem($materialItemId: String!, $limit: Int) {
  assignmentHistoryByItem(materialItemId: $materialItemId, limit: $limit) {
    ...HardgoodsAssignmentSummary
  }
}
    fragment HardgoodsAssignmentTask on AssignmentTaskSummary {
  binLocationId
  completedAt
  materialItemId
  startedAt
  status
  taskId
}
fragment HardgoodsAssignmentSummary on AssignmentSummaryDocument {
  assignmentId
  createdAt
  dueBy
  notes
  previousWorkerUserId
  status
  tasks {
    key
    value {
      ...HardgoodsAssignmentTask
    }
  }
  workerReassignedAt
  workerUserId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetHardgoodsInventoryGrid: build.query<GetHardgoodsInventoryGridQuery, GetHardgoodsInventoryGridQueryVariables | void>({
      query: (variables) => ({ document: GetHardgoodsInventoryGridDocument, variables })
    }),
    GetHardgoodsAvailability: build.query<GetHardgoodsAvailabilityQuery, GetHardgoodsAvailabilityQueryVariables | void>({
      query: (variables) => ({ document: GetHardgoodsAvailabilityDocument, variables })
    }),
    GetHardgoodsRequiredByNeededWeekRange: build.query<GetHardgoodsRequiredByNeededWeekRangeQuery, GetHardgoodsRequiredByNeededWeekRangeQueryVariables>({
      query: (variables) => ({ document: GetHardgoodsRequiredByNeededWeekRangeDocument, variables })
    }),
    GetAssignmentHistoryByItem: build.query<GetAssignmentHistoryByItemQuery, GetAssignmentHistoryByItemQueryVariables>({
      query: (variables) => ({ document: GetAssignmentHistoryByItemDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetHardgoodsInventoryGridQuery, useLazyGetHardgoodsInventoryGridQuery, useGetHardgoodsAvailabilityQuery, useLazyGetHardgoodsAvailabilityQuery, useGetHardgoodsRequiredByNeededWeekRangeQuery, useLazyGetHardgoodsRequiredByNeededWeekRangeQuery, useGetAssignmentHistoryByItemQuery, useLazyGetAssignmentHistoryByItemQuery } = injectedRtkApi;
